import { createBrowserRouter } from "react-router";
import {
  LoginPasswordEntry,
  LoginMFAChallenge,
  SetNewPasswordForm,
  ForgotPasswordEmail,
  ForgotPasswordCheckEmail,
  ResetPasswordForm,
  ResetPasswordSuccess,
  SetupMFAIntroduction,
  SetupMFAQRCode,
  SetupMFAVerifyAndBackup,
  SetupComplete,
  ProtectedRoute,
} from "@duvi-agency/auth";
import { Dashboard } from "./pages/Dashboard";
import { KnowledgeBaseList } from "./pages/KnowledgeBaseList";
import { KnowledgeBaseEditor } from "./pages/KnowledgeBaseEditor";
import { SupportTicketsList } from "./pages/SupportTicketsList";
import { SupportTicketDetail } from "./pages/SupportTicketDetail";
import { UserManagement } from "./pages/UserManagement";
import { UserDetail } from "./pages/UserDetail";
import { AuditLog } from "./pages/AuditLog";
import { NichesList } from "./pages/NichesList";
import { Settings } from "./pages/Settings";

function Protected({ children }: { children: React.ReactNode }) {
  return <ProtectedRoute>{children}</ProtectedRoute>;
}

export const router = createBrowserRouter([
  {
    path: "/",
    children: [
      {
        index: true,
        element: <LoginPasswordEntry />,
      },
      {
        path: "auth",
        children: [
          { index: true, element: <LoginPasswordEntry /> },
          { path: "password", element: <LoginPasswordEntry /> },
          { path: "mfa", element: <LoginMFAChallenge /> },
          { path: "new-password", element: <SetNewPasswordForm /> },
          {
            path: "forgot-password",
            children: [
              { index: true, element: <ForgotPasswordEmail /> },
              { path: "check-email", element: <ForgotPasswordCheckEmail /> },
            ],
          },
          {
            path: "reset-password",
            children: [
              { index: true, element: <ResetPasswordForm /> },
              { path: "success", element: <ResetPasswordSuccess /> },
            ],
          },
        ],
      },
      {
        path: "setup",
        children: [
          {
            path: "mfa",
            children: [
              { index: true, element: <SetupMFAIntroduction /> },
              { path: "scan", element: <SetupMFAQRCode /> },
              { path: "verify", element: <SetupMFAVerifyAndBackup /> },
            ],
          },
          { path: "complete", element: <SetupComplete /> },
        ],
      },
      // --- Protected app routes ---
      {
        path: "dashboard",
        element: (
          <Protected>
            <Dashboard />
          </Protected>
        ),
      },
      {
        path: "knowledge-base",
        children: [
          {
            index: true,
            element: (
              <Protected>
                <KnowledgeBaseList />
              </Protected>
            ),
          },
          {
            path: "new",
            element: (
              <Protected>
                <KnowledgeBaseEditor />
              </Protected>
            ),
          },
          {
            path: ":id",
            element: (
              <Protected>
                <KnowledgeBaseEditor />
              </Protected>
            ),
          },
        ],
      },
      {
        path: "support/tickets",
        children: [
          {
            index: true,
            element: (
              <Protected>
                <SupportTicketsList />
              </Protected>
            ),
          },
          {
            path: ":id",
            element: (
              <Protected>
                <SupportTicketDetail />
              </Protected>
            ),
          },
        ],
      },
      {
        path: "user-management",
        children: [
          {
            index: true,
            element: (
              <Protected>
                <UserManagement />
              </Protected>
            ),
          },
          {
            path: ":userId",
            element: (
              <Protected>
                <UserDetail />
              </Protected>
            ),
          },
        ],
      },
      {
        path: "platform/niches",
        element: (
          <Protected>
            <NichesList />
          </Protected>
        ),
      },
      {
        path: "audit-log",
        element: (
          <Protected>
            <AuditLog />
          </Protected>
        ),
      },
      {
        path: "settings",
        element: (
          <Protected>
            <Settings />
          </Protected>
        ),
      },
    ],
  },
]);
